import Sortable from 'sortablejs';
import { appStore } from '../state/store.js';
import { PDFRenderer } from '../pdf/pdfRenderer.js';

export class Thumbnails {
    constructor(containerId) {
        this.container = document.getElementById(containerId);
        this.unsubscribe = null;
        this.sortable = null;

        this.init();
    }

    init() {
        this.unsubscribe = appStore.subscribe((state, eventType, payload) => {
            if (eventType === 'PAGES_CHANGED') {
                this.render(state.pages);
                this.updateSelection(state.selection);
            } else if (eventType === 'SELECTION_CHANGED') {
                this.updateSelection(state.selection);
            }
        });

        // Initialize SortableJS
        this.sortable = new Sortable(this.container, {
            animation: 150,
            ghostClass: 'sortable-ghost',
            onEnd: (evt) => {
                const { oldIndex, newIndex } = evt;
                if (oldIndex !== newIndex) {
                    appStore.movePage(oldIndex, newIndex);
                }
            }
        });
    }

    render(pages) {
        this.container.innerHTML = '';

        pages.forEach((page, index) => {
            const el = document.createElement('div');
            el.className = 'thumbnail-item';
            el.dataset.id = page.id;
            el.dataset.index = index;

            // Layout: 
            // - Number
            // - Canvas wrapper

            el.innerHTML = `
                <div class="page-number">${index + 1}</div>
                <div class="thumb-canvas-wrapper">
                    <canvas id="thumb-canvas-${page.id}"></canvas>
                </div>
            `;

            el.addEventListener('click', (e) => {
                const multi = e.metaKey || e.ctrlKey; // simple multiselect
                appStore.selectPage(page.id, multi);
            });

            this.container.appendChild(el);

            // Queue render
            this.renderThumbnail(page, el.querySelector('canvas'));
        });
    }

    updateSelection(selection) {
        const items = this.container.querySelectorAll('.thumbnail-item');
        items.forEach(item => {
            if (selection.includes(item.dataset.id)) {
                item.classList.add('selected');
                item.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            } else {
                item.classList.remove('selected');
            }
        });
    }

    async renderThumbnail(page, canvas) {
        // Basic intersection observer check could go here
        try {
            // Render with low scale
            // We need to respect rotation for the thumbnail too
            // PDFRenderer.renderPage handles rendering logic. 
            // But we need to handle rotation CSS or canvas rotation
            // PDF.js handles rotation if we pass it, but better to render straight and rotate canvas with CSS? 
            // Or rotate context?

            // For now, simple render:
            await PDFRenderer.renderPage(page.docId, page.pageIndex, canvas, 0.2);

            // Apply rotation visuals
            if (page.rotation) {
                canvas.style.transform = `rotate(${page.rotation}deg)`;
            }
        } catch (err) {
            console.error('Thumbnail render error', err);
        }
    }
}
